import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slider", "description"]
  static values = { updateUrl: String }
  
  connect() {
    this.timeout = null
    this.updateInProgress = false
  }

  autosave(event) {
    // Clear any existing timeout
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    // Get the tag ID and field that changed
    const tagId = event.target.dataset.tagId
    const field = event.target.name.includes('penalty_score') ? 'penalty_score' : 'internal_description'
    const value = event.target.value

    // Show visual feedback
    const card = event.target.closest('.card')
    card.classList.add('saving')

    // Update display for penalty score in real-time
    if (field === 'penalty_score') {
      const displayElement = card.querySelector('.penalty-score-display .fs-2')
      displayElement.textContent = value
      
      // Update color based on score
      displayElement.classList.remove('text-success', 'text-warning', 'text-danger')
      if (value < 40) {
        displayElement.classList.add('text-success')
      } else if (value < 70) {
        displayElement.classList.add('text-warning')
      } else {
        displayElement.classList.add('text-danger')
      }
    }

    // Debounce the save request
    this.timeout = setTimeout(() => {
      this.save(tagId, field, value, card)
    }, 500)
  }

  async save(tagId, field, value, card) {
    if (this.updateInProgress) return
    this.updateInProgress = true

    try {
      const formData = new FormData()
      formData.append('tag[' + field + ']', value)
      formData.append('authenticity_token', document.querySelector('meta[name="csrf-token"]').content)

      const response = await fetch(this.updateUrlValue, {
        method: 'PATCH',
        body: formData,
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      })

      const data = await response.json()

      if (data.success) {
        // Show success feedback
        card.classList.remove('saving')
        card.classList.add('saved')
        setTimeout(() => {
          card.classList.remove('saved')
        }, 1000)
      } else {
        // Show error
        card.classList.remove('saving')
        card.classList.add('error')
        console.error('Save failed:', data.errors)
      }
    } catch (error) {
      console.error('Network error:', error)
      card.classList.remove('saving')
      card.classList.add('error')
    } finally {
      this.updateInProgress = false
    }
  }
}